import React, { HTMLProps, memo } from "react";
import classnames from "classnames";
import { PREFIX } from "src/constants";
import { Element } from "../base";

interface IProps extends HTMLProps<HTMLElement> {
    className?: string;
    children: React.ReactNode;
    active?: boolean;
    dropdown?: boolean;
    dropdownUp?: boolean;
    hoverable?: boolean;
    renderAs?: string;
    arrowless?: string;
    domRef?: any;
}

function NavbarItem(props: IProps) {
    const {
        className,
        active,
        children,
        dropdown,
        dropdownUp,
        hoverable,
        renderAs = "li",
        arrowless,
        ...rest
    } = props;
    let as = renderAs;

    return (
        <Element
            {...rest}
            renderAs={as}
            className={classnames(`${PREFIX}-navbar-item`, "block", className, {
                ["is-active"]: active,
                ["has-dropdown"]: dropdown,
                ["is-hoverable"]: hoverable,
                ["has-dropdown-up"]: dropdownUp,
                ["is-arrowless"]: arrowless,
            })}
        >
            {children}
        </Element>
    );
}

export default memo(NavbarItem);
